import { render, staticRenderFns } from "./splashScreenManage.vue?vue&type=template&id=0dce78f0&scoped=true&"
import script from "./splashScreenManage.vue?vue&type=script&lang=js&"
export * from "./splashScreenManage.vue?vue&type=script&lang=js&"
import style0 from "./splashScreenManage.vue?vue&type=style&index=0&id=0dce78f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce78f0",
  null
  
)

export default component.exports